export default __webpack_public_path__ + "locales/sr-Latn-RS/SMTPSettings.json?hash=18cf42535f5867ce44c7763f38279712";